module.exports = __webpack_public_path__ + "media/servicesPages/listIcon2-46e7ee4a.png";